import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloSneakers } from '@/mocks/articles';

export default function SneakersPage() {
  return <ArticleLayout article={articoloSneakers} />;
}